import styled from 'styled-components';
import { glassSurface } from './GlassSurface';

export const ListItem = styled.li`
  ${glassSurface};
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
